import { useEffect, useState } from 'react';
import { throttle } from '@carvana/purchase-utils';

const useElementResize = () => {
  const [elementResize, setElementResize] = useState(null);
  const onElementResize = throttle(() => setElementResize(Date.now()), 250);
  const orientationChanged = () => {
    setTimeout(() => {
      onElementResize();
    }, 400);
  };

  useEffect(() => {
    const windowHandlers = [
      ['resize', onElementResize],
      ['orientationchange', orientationChanged]
    ];

    windowHandlers.forEach(([event, handler]) => {
      window.addEventListener(event, handler);
    });

    return () => {
      windowHandlers.forEach(([event, handler]) => {
        window.removeEventListener(event, handler);
      });
    };
  }, []);

  return [elementResize];
};

export default useElementResize;
